module.exports = __webpack_public_path__ + "img/tu01.f2eebfe1.png";